import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@material-ui/core/Tooltip';

const HybridContent = props => {
  const { type, data, details } = props;
  switch (type) {
    case 'currency':
      return details ? (
        <Tooltip title={details}>
          &euro;
          {data}
        </Tooltip>
      ) : (
        <>
          &euro;
          {data}
        </>
      );

    default:
      return details ? <Tooltip title={details}>{data}</Tooltip> : <>{data}</>;
  }
};

HybridContent.propTypes = {
  type: PropTypes.oneOf(['string', 'number', 'date', 'boolean', 'currency', 'composed']),
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  details: PropTypes.string,
};

HybridContent.defaultProps = {
  type: 'string',
  details: undefined,
};

export default HybridContent;
